module.exports = __webpack_public_path__ + "static/media/materialdesignicons-webfont.7fb0e378.woff2";